module.exports = __webpack_public_path__ + "img/shhg.ebe62817.png";